<script setup>
import { Link } from '@inertiajs/vue3'
import SmallNavLogo from '@images/small-nav-logo.svg'
</script>

<template>
  <Link href="/">
    <img :src="SmallNavLogo" alt="Convict Records" />
  </Link>
</template>
